import { createClient } from '@supabase/supabase-js';
import { createCoalescingFetch } from './coalescing-fetch';

if (import.meta.env.VITE_SUPABASE_URL === undefined) {
    throw new Error('Please set the VITE_SUPABASE_URL environment variable');
}
if (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY === undefined) {
    throw new Error(
        'Please set the VITE_SUPABASE_PUBLISHABLE_KEY environment variable'
    );
}

const coalescingFetch = createCoalescingFetch(fetch);

/**
 * Fetch implementation that logs every request and uses coalescing for GET/HEAD.
 * Use this whenever you want Supabase REST calls to appear in logs (e.g. custom httpClient for ra-supabase).
 */
export function loggedFetch(
    input: RequestInfo | URL,
    init?: RequestInit
): Promise<Response> {
    const url =
        typeof input === 'string'
            ? input
            : input instanceof URL
              ? input.href
              : (input as Request).url;
    const method = init?.method ?? 'GET';
    const startTime = performance.now();
    return coalescingFetch(input, init).then(response => {
        const endTime = performance.now();
        const duration = endTime - startTime;
        console.log(
            `[Supabase] ${method} ${url} → ${response.status} ${response.statusText} in ${duration.toFixed(2)}ms`
        );
        return response;
    });
}

export const supabase = createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    {
        global: {
            fetch: loggedFetch,
            headers: {
                'X-Time-Zone': 'Europe/Paris',
                'X-Locale': 'en-US',
            },
        },
    }
);
